//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function updateLeadService(lead) {
    try {
        await api.put(`/leads/${lead.id}`, lead);
        toast.success("Lead atualizado com sucesso");
        return true;
    } catch (err) {
        if (err.response?.status === 409) {
            toast.error(err.response.data.error || "Já existe um lead com este telefone");
        } else {
            toast.error("Erro ao atualizar lead");
        }
        return false;
    }
}